import { ApiError } from '../../services/api';

/** Load-more footer for cursor lists: next-page failures stay INLINE
 *  (the loaded rows remain visible) with retry on the button. */
export function LoadMoreButton({
  hasMore,
  loadingMore,
  loadMoreError,
  onLoadMore,
}: {
  hasMore: boolean;
  loadingMore: boolean;
  loadMoreError: unknown;
  onLoadMore: () => void;
}) {
  if (!hasMore && loadMoreError === null) return null;
  return (
    <div className="load-more">
      {loadMoreError !== null && (
        <span className="load-more-error" role="alert">
          {loadMoreError instanceof ApiError || loadMoreError instanceof Error
            ? loadMoreError.message
            : 'Failed to load more'}
        </span>
      )}
      {hasMore && (
        <button
          type="button"
          className="btn btn-secondary"
          disabled={loadingMore}
          onClick={onLoadMore}
        >
          {loadingMore ? 'Loading…' : loadMoreError !== null ? 'Retry' : 'Load more'}
        </button>
      )}
    </div>
  );
}
